// The conversation in the platform agent's panel. Wording from the Amigo design's copy sheet; `steps` labels the
// step list (keys in platformAgentConversation.js). The working line's labels are docs/platform-agent/contracts.md
// §5's table, in services/platform-agent/stepLabels.js.
export default {
  conversation: 'Conversazione',
  working: 'Elaborazione in corso…',
  stopped: 'Interrotto. Nulla è cambiato.',
  step_stopped: 'Interrotto',
  steps_completed_one: '{{count}} passaggio completato',
  steps_completed_other: '{{count}} passaggi completati',
  chart: {
    table: 'I dati di questo grafico',
    label: 'Etichetta',
    value: 'Valore',
  },
  // A form of several values Amigo needs at once (ask_form, contracts §5).
  form: {
    submit: 'Continua',
    skip: 'Salta per ora',
    required: 'Compila per continuare',
    generated: 'Creato per te quando approvi',
    step_of: 'Passaggio {{index}} di {{total}}',
    on: 'Attivo',
    off: 'Disattivo',
    skipped: 'Saltato per ora',
  },
  next_steps: 'Prossimi passaggi',
  action_card: {
    select_restaurant: 'Seleziona questo ristorante',
    open_page: 'Si apre nella dashboard',
  },
  not_sent: 'Non inviato',
  failed: {
    text: 'Qualcosa è andato storto da parte mia, quindi nulla è cambiato. Riprova tra un momento.',
    retry: 'Riprova',
  },
  question: {
    other: 'Altro…',
    send: 'Invia',
    label: 'Domanda',
    type_answer: 'Altro? Scrivilo qui sotto.',
    label_many: 'Domande',
    step_of: '{{index}} di {{total}}',
    previous: 'Domanda precedente',
    next: 'Domanda successiva',
    dismiss: 'Non ora',
  },
  unavailable: {
    title: {
      amigo: 'Amigo non è disponibile al momento.',
      assistant: "L'assistente non è disponibile al momento.",
    },
    text: 'Nulla è cambiato e il resto della dashboard funziona normalmente. Riprova tra qualche minuto.',
  },
  // A chat that goes on over several days (D4): a line before each day's first message, and Today to carry on.
  today: 'Oggi',
  when: {
    today: 'Oggi, {{time}}',
    yesterday: 'Ieri, {{time}}',
    date: '{{date}}, {{time}}',
  },
  new_chat_line: 'Nuova chat per {{restaurant}}. Le chat di {{previous}} si trovano in Chat quando ci torni.',
  // A restaurant selected during a chat with no restaurant selected (D18): the chat carries on there, or a new one starts.
  carried_on_line: 'Ora su {{restaurant}}. Questa chat prosegue e viene salvata con le sue chat.',
  from_none_line:
    'Nuova chat per {{restaurant}}. La tua chat su {{earlier}} è in Chat, senza un ristorante selezionato.',
  from_none_line_unnamed:
    'Nuova chat per {{restaurant}}. La tua chat precedente è in Chat, senza un ristorante selezionato.',
  // Someone else's chat, opened by our team (D4): whose it is, by who started it (contracts §6 `started_by.kind`).
  read_only: {
    whose: {
      foodamigos: 'Chat di {{name}} (FoodAmigos)',
      owner: 'Chat di {{name}} (titolare)',
      staff: 'Chat di {{name}} (staff)',
      partner: 'Chat di {{name}} (partner)',
      other: 'Chat di {{name}}',
      unnamed: 'Chat di un altro utente',
    },
    text: 'Chat di {{name}}. Puoi leggerla, ma non rispondere né approvare le sue schede.',
    text_unnamed: 'Chat di un altro utente. Puoi leggerla, ma non rispondere né approvare le sue card.',
    new_chat: 'Nuova chat',
  },
  // A chat whose eve session can't go on (QA42): read only, and New chat takes the message that didn't go with it.
  ended: {
    text: 'Questa chat è terminata. Avvia una nuova chat per continuare.',
    new_chat: 'Nuova chat',
    moved_line: 'Nuova chat, perché la precedente era terminata',
  },
  composer: {
    label: 'Messaggio',
    placeholder: 'Fai una domanda o descrivi una modifica',
    placeholder_answer: 'Digita la tua risposta',
    hint: 'Invio per inviare · Maiusc+Invio per andare a capo',
  },
  table: {
    show_all: 'Mostra tutte le {{count}} righe',
    show_fewer: 'Mostra meno',
  },
  steps: {
    areas: 'Verifico in cosa posso aiutarti qui',
    area_describe: 'Sto esaminando {{area}}',
    restaurants: 'Ricerca del ristorante',
    read: 'Sto leggendo i tuoi dati',
    propose: 'Sto preparando la modifica',
    change_set_get: 'Sto controllando la modifica',
    change_set_undo: "Preparazione dell'annullamento",
    change_set_withdraw: 'Chiusura della scheda',
    gap_record: 'Lo annoto per il nostro team',
    research: 'Sto cercando come funziona',
    screen_find: 'Sto cercando la pagina giusta',
    file_read: 'Sto leggendo il tuo file',
    attach_chat_file: 'Preparazione del file in corso',
    shop_check: 'Sto controllando il tuo shop',
    area_describe_other: "Sto guardando quest'area",
    other: 'Sto controllando qualcosa',
  },
  // What a step that failed says it couldn't do (QL46), by the area it worked in; `other` is the label without an
  // area. contracts §5's Failed steps, kept the same as STEP_FAILED_LABELS in stepLabels.js (a test holds en and de).
  failed_steps: {
    restaurants: {
      other: 'Impossibile trovare il ristorante',
    },
    read: {
      menu: 'Impossibile leggere il menu',
      hours: 'Impossibile leggere gli orari di apertura',
      order_settings: 'Impossibile leggere le impostazioni degli ordini',
      my_info: 'Impossibile leggere i tuoi dati',
      marketing: 'Impossibile leggere il tuo marketing',
      gift_cards: 'Impossibile leggere le carte regalo',
      reports: 'Impossibile leggere i tuoi numeri',
      other: 'Impossibile leggere i tuoi dati',
    },
    propose: {
      menu: 'Impossibile preparare la modifica del menu',
      hours: 'Impossibile preparare la modifica degli orari di apertura',
      order_settings: 'Impossibile preparare la modifica delle impostazioni degli ordini',
      my_info: 'Impossibile preparare la modifica dei tuoi dati',
      marketing: 'Impossibile preparare la modifica del marketing',
      gift_cards: 'Impossibile preparare la modifica delle carte regalo',
      other: 'Impossibile preparare la modifica',
    },
    change_set_get: { other: 'Impossibile verificare la modifica' },
    change_set_undo: { other: "Impossibile preparare l'annullamento" },
    change_set_withdraw: { other: 'Impossibile chiudere la scheda' },
    research: { other: 'Impossibile cercare come funziona' },
    screen_find: { other: 'Impossibile trovare la pagina' },
    file_read: { other: 'Impossibile leggere il tuo file' },
    attach_chat_file: { other: 'Impossibile preparare il file' },
    shop_check: { other: 'Impossibile aprire il tuo negozio' },
  },
  // The areas of contracts §0 as the steps name them ("Looking at {{area}}").
  areas: {
    menu: 'il menu',
    hours: 'gli orari di apertura',
    order_settings: 'le impostazioni degli ordini',
    my_info: 'le info del tuo ristorante',
    marketing: 'il marketing',
    reports: 'i report',
  },
};
